export var VendorStatus;
(function (VendorStatus) {
    VendorStatus[VendorStatus["NORMAL"] = 1] = "NORMAL";
    VendorStatus[VendorStatus["PREFERRED"] = 2] = "PREFERRED";
    VendorStatus[VendorStatus["HOLD"] = 3] = "HOLD";
    VendorStatus[VendorStatus["CANCELLED"] = 4] = "CANCELLED";
})(VendorStatus || (VendorStatus = {}));
//# sourceMappingURL=vendor-status.js.map